import React, { useCallback, useMemo } from 'react';

import { ExtendedWorkspaceListItem } from '@futrli/views/operations/workspaces/processors/workspacesList';
import { useIntl } from '@futrli/localisation';
import { VirtualizedCardList } from '@futrli/predict/ui/virtualized-card-list/virtualized-card-list';
import { VirtualizedCardListEmptyState } from '@futrli/predict/ui/virtualized-card-list/virtualized-card-list-empty-state';

import {
  OrganisationRow,
  ROW_HEIGHT_DEFAULT,
  WorkspaceOrganisationListItem
} from './components/organisation-row/organisation-row';

interface WorkspacesListProps {
  workspaces?: ExtendedWorkspaceListItem[];
  isLoading?: boolean;
  hideWorkspaceColumn?: boolean;
}

export const WorkspacesOrganisationsList = ({
  workspaces = [],
  isLoading = false,
  hideWorkspaceColumn = false
}: WorkspacesListProps) => {
  const intl = useIntl();

  const data = useMemo<WorkspaceOrganisationListItem[]>(
    () =>
      workspaces.flatMap(workspace =>
        workspace.organisations.map(organisation => ({
          workspace,
          organisation
        }))
      ),
    [workspaces]
  );

  const renderRow = useCallback(
    (item: WorkspaceOrganisationListItem) => {
      return <OrganisationRow item={item} hideWorkspaceColumn={hideWorkspaceColumn} />;
    },
    [hideWorkspaceColumn]
  );

  const rowHeight = useCallback(() => ROW_HEIGHT_DEFAULT, []);

  return (
    <VirtualizedCardList<WorkspaceOrganisationListItem>
      data={data}
      renderRow={renderRow}
      rowHeight={rowHeight}
      isLoading={isLoading}
      emptyState={
        <VirtualizedCardListEmptyState
          title={intl.formatMessage({
            id: 'predict.workspaces.no_organisations',
            defaultMessage: 'No organisations to show'
          })}
        />
      }
    />
  );
};
